import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// 自定义
import '@/styles/css/base.css'
import '@/styles/css/global.css'
// 第三方
import '@/styles/css/quill/quill.core.css'
import '@/styles/css/quill/quill.snow.css'
import '@/styles/css/quill/quill.bubble.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import '@/utils/js/beattext/jquery.beattext.js'
import '@/utils/js/beattext/easying.js'
// 注册
Vue.use(ElementUI)
/** 中央事件总线
 * 发送广播: this.$root.Bus.$emit('broadcastName')
 * 接收广播: this.$root.Bus.$on('broadcastName', content => {})
 * 销毁广播: this.$root.Bus.$off('broadcastName');生命钩子:beforeDestroy(){}
 */
const Bus = new Vue()
Vue.config.productionTip = false
// 禁止返回
// $(function() {
//   if (window.history && window.history.pushState) {
//     $(window).on('popstate', function () {
//       window.history.pushState('forward', null, '#');
//       window.history.forward(1);
//     });
//   }
//   window.history.pushState('forward', null, '#'); //在IE中必须得有这两行
//   window.history.forward(1);
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: { Bus },
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js